import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import ContentHeader from 'component/utils/ContentHeader'
import QueryLogsTable from 'component/queryLogsNew/Table'
import Modal from 'component/queryLogsNew/Modal'
import * as queryLogActions from 'action/queryLog'
import * as reportActions from 'action/report'
import NewPagination from 'component/pagination/newPagination'
import Col from 'component/utils/Col'
import Row from 'component/utils/Row'
import moment from 'moment'
import Form from 'component/commonReport/Form'
import SideFilter from 'component/queryLogsNew/SideFilter'
import FilterIconSVG from 'component/svgComponents/filter'

import Button from 'component/Button'
import { colourStyles } from 'utils/selectStyle'
import SizeSelect, { components } from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { normalizeFilterParams, normalizeDateAndTime, prepareParamsForBackend } from 'utils/queryLogsNormalization'

const PAGINATION_OPTIONS = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
]

let signalController

class QueryLogs extends Component {
  state = {
    showInitialFilter: true,
    showBackToSourceButton: false,
    showSideFilter: false,
    filterValues: {
      idBranch: '',
      functionality: '',
      listId: '',
      dtPeriod: [],
      hrPeriod: [],
    },
    pagination: {
      page: 1,
      size: 10,
    },
    modal: {
      data: {},
      render: false
    },
    paramsState: null,
    storeName: '',
    direction: 'asc',
  }

  headerRef = React.createRef()

  filterRef = React.createRef()

  tableRef = React.createRef()

  appliedQuerySearch = null

  componentDidMount() {
    this.tryApplyQueryPrefill()
  }

  componentDidUpdate(prevProps) {
    const prevSearch = prevProps.location && prevProps.location.search
    const nextSearch = this.props.location && this.props.location.search
    if (nextSearch !== prevSearch) {
      this.appliedQuerySearch = null
      this.tryApplyQueryPrefill()
    }
  }

  tryApplyQueryPrefill = () => {
    const { location } = this.props
    if (!location || !location.search) return
    if (location.search === this.appliedQuerySearch) return

    const q = location.query || {}
    if (!q.functionality || !q.dtStart || !q.dtEnd) return

    const mStart = moment(q.dtStart, 'YYYY-MM-DD', true)
    const mEnd = moment(q.dtEnd, 'YYYY-MM-DD', true)
    if (!mStart.isValid() || !mEnd.isValid()) return

    this.appliedQuerySearch = location.search
    this.setState({ showBackToSourceButton: true })

    const { pagination: { size } } = this.state
    this.handleFilter({
      idBranch: q.idBranch != null && q.idBranch !== '' ? String(q.idBranch) : '',
      functionality: q.functionality,
      listId: q.listId != null && q.listId !== '' ? String(q.listId) : '',
      dtPeriod: [mStart, mEnd],
      hrPeriod:
        q.hourStart || q.hourEnd
          ? [q.hourStart || '00:00', q.hourEnd || '23:59']
          : ['', ''],
      storeName: q.riStoreName ? String(q.riStoreName) : '',
      page: 1,
      size: size || 10,
    })
  }

  handleLogQueryNavBack = () => {
    const { clearQueryLog, location } = this.props
    const { filterValues } = this.state
    const functionalityFromQuery = location && location.query && location.query.functionality
    const functionality = functionalityFromQuery || filterValues.functionality

    clearQueryLog()
    this.appliedQuerySearch = null

    if (functionality === 'score.stock.request' || functionality === 'score.stock.response') {
      const q = (location && location.query) || {}
      const params = new URLSearchParams()
      const restoreKeys = [
        'stDtStart',
        'stDtEnd',
        'stBranchIdList',
        'stSectionIdList',
        'stOriginList',
        'stDestinyList',
        'stStatus',
        'stCdLm',
      ]

      restoreKeys.forEach((key) => {
        const value = q[key]
        if (value !== undefined && value !== null && value !== '') {
          params.set(key, String(value))
        }
      })

      browserHistory.push(
        params.toString()
          ? `/stock-transfer/report-new?${params.toString()}`
          : '/stock-transfer/report-new'
      )
      return
    }

    if (functionality === 'score.irc') {
      const q = (location && location.query) || {}
      const params = new URLSearchParams()
      const restoreKeys = [
        'riDtStart',
        'riDtEnd',
        'riIdBranches',
        'riLsSections',
        'riCdLm',
        'riIntegratedStatus',
        'riIncludeLot',
        'riStoreName',
      ]

      restoreKeys.forEach((key) => {
        const value = q[key]
        if (value !== undefined && value !== null && value !== '') {
          params.set(key, String(value))
        }
      })

      browserHistory.push(
        params.toString()
          ? `/rotative-inventory?${params.toString()}`
          : '/rotative-inventory'
      )
      return
    }

    browserHistory.push('/query-logs')
  }

  componentWillUnmount() {
    if (signalController) {
      signalController.abort()
    }
  }

  get functionalityOptions() {
    const options = [
      { value: 'score.irc', label: 'query.logs.score.irc' },
      { value: 'score.punctual', label: 'query.logs.punctual.adjust' },
      { value: 'score.stock.request', label: 'query.logs.score.stock.request' },
      { value: 'score.stock.response', label: 'query.logs.score.stock.response' },
      // TODO: Futuramente essas funcionalidades poderão ser usadas
      // { value: 'pricebanner.preview.request', label: 'query.logs.pricebanner.preview.request'},
      // { value: 'pricebanner.request', label: 'query.logs.pricebanner.request' },
      // { value: 'datasheet.preview.request', label: 'issuance.datasheet' },
      // { value: 'datasheet.request', label: 'preview.ficha.tecnical' },
      { value: 'request.external', label: 'query.logs.request.external' },
      { value: 'use.consume', label: 'use.consume' },
      { value: 'demarcate', label: 'query.logs.demarcate' }
    ]

    return options
      .map((option) => ({
        value: option.value,
        label: this.props.translate(option.label),
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }

  get formFields() {
    const {
      translate,
      auth: { user }
    } = this.props

    return [
      {
        type: 'branchs_without_multselect',
        name: 'idBranch',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        attrs: {
          withoutRegions: true
        },
        required: !user.isLdapInManager
      },
      {
        type: 'select',
        name: 'functionality',
        label: translate('query.logs.modal.functionality'),
        help_text: translate('query.logs.functionality.new'),
        options: this.functionalityOptions,
        required: true,
      },
      {
        type: 'input',
        name: 'listId',
        label: translate('lm_label'),
        help_text: translate('query.logs.listId.new'),
        attrs: {
          maxLength: 8,
          mask: '99999999'
        }
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        attrs: {
          maxRange: null
        }
      },
      {
        type: 'hour_range',
        name: 'hrPeriod',
        help_text: '00:00',
      },
    ]
  }

  handleFilter = ({ idBranch, functionality, listId = '', dtPeriod, hrPeriod, direction, page, size, branchObject, storeName: storeNameOverride }) => { // eslint-disable-line
    const {
      fetchQueryLog,
      fetchFilter,
      clearQueryLog,
      auth: { user }
    } = this.props
    const {
      pagination: { page: statePage, size: stateSize },
      direction: stateDirection,
      showInitialFilter
    } = this.state

    const finalPage = page !== undefined ? page : statePage
    const finalSize = size !== undefined ? size : stateSize
    const finalDirection = direction !== undefined ? direction : stateDirection

    if (showInitialFilter) {
      clearQueryLog()
    }

    if (signalController) {
      signalController.abort()
    }

    let storeName = storeNameOverride || ''
    if (branchObject && branchObject.label) {
      const parts = branchObject.label.split(' - ')
      if (parts.length > 1) {
        const rawName = parts.slice(1).join(' - ').trim()
        storeName = rawName.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      }
    } else {
      const { storeName: currentStoreName, filterValues } = this.state
      if (currentStoreName && filterValues && filterValues.idBranch === idBranch) {
        storeName = currentStoreName
      }
    }

    const oldParams = {
      idBranch,
      functionality,
      listId,
      dtPeriod,
      hrPeriod,
      page: finalPage,
      size: finalSize,
      direction: finalDirection
    }

    fetchFilter(oldParams)

    const normalizedParams = normalizeFilterParams(idBranch, functionality, listId)
    const dateTimeParams = normalizeDateAndTime(dtPeriod, hrPeriod)
    const params = prepareParamsForBackend(functionality, normalizedParams, dateTimeParams, finalPage, finalSize, finalDirection)

    this.setState({
      showInitialFilter: false,
      showSideFilter: false,
      filterValues: { idBranch, functionality, listId, dtPeriod, hrPeriod },
      pagination: { page: finalPage, size: finalSize },
      paramsState: oldParams,
      storeName,
      direction: finalDirection
    })

    signalController = new AbortController()
    fetchQueryLog(user.dsToken, params, signalController)
  }

  getPage = (page) => {
    const { paramsState } = this.state

    if (paramsState) {
      const updatedParams = { ...paramsState, page }
      this.handleFilter(updatedParams)
    }
  }

  getSize = (size) => {
    const { paramsState } = this.state

    if (paramsState) {
      const updatedParams = { ...paramsState, page: 1, size }
      this.handleFilter(updatedParams)
    }
  }

  handleDownload = (log) => {
    const { translate } = this.props
    const {
      filterValues: { functionality }
    } = this.state
    const element = document.createElement('a')

    const file = new Blob(
      [
        `\n${translate('query.logs.modal.functionality')}\n`,
        translate('query.logs.'.concat(functionality)),
        '\n\n',
        translate('query.logs.modal.date'),
        '\n',
        moment(log.date).format('l'),
        '\n\n',
        translate('query.logs.modal.hour'),
        '\n',
        moment(log.date).format('HH:mm:ss'),
        '\n\n',
        translate('queryLogs.table.column.endpoint'),
        '\n',
        log.endpoint,
        '\n\n',
        translate('query.logs.modal.request'),
        '\n',
        log.request,
        '\n\n',
        translate('query.logs.modal.response'),
        '\n',
        log.response,
      ],
      { type: 'text/plain' }
    )

    element.href = URL.createObjectURL(file)
    element.download = 'logs.txt'
    document.body.appendChild(element)
    element.click()
    element.parentElement.removeChild(element)
  }

  openModal = ({ request, response, endpoint, date, transactionSap }) => {
    const {
      filterValues: { functionality }
    } = this.state

    this.setState({
      modal: {
        render: true,
        data: { request, response, endpoint, date, functionality, transactionSap }
      }
    })
  }

  renderModal() {
    const {
      modal: { data }
    } = this.state
    const { translate } = this.props

    return (
      <Modal
        handleDownload={this.handleDownload}
        data={data}
        translate={translate}
        closeModal={() => this.setState({
          modal: {
            render: false,
            data: {}
          }
        })}
      />
    )
  }

  fetchDir = (direction) => { // eslint-disable-line
    const { paramsState } = this.state

    if (paramsState) {
      const updatedParams = { ...paramsState, direction }
      this.handleFilter(updatedParams)
    }
  }

  renderHeaderText = (filterValues, translate) => {
    if (filterValues.idBranch) {
      const { storeName } = this.state
      const displayName = storeName || ''
      return `${filterValues.idBranch} - ${displayName} - ${translate('query.logs.'.concat(filterValues.functionality))}`
    }
    return `${translate('select-header-stores-select-all')} - ${translate('query.logs.'.concat(filterValues.functionality))}`
  }

  DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
      <DropdownArrow />
    </components.DropdownIndicator>
  )

  render() {
    const { translate, count, current, pages, list } = this.props
    const {
      showInitialFilter,
      showBackToSourceButton,
      showSideFilter,
      filterValues,
      pagination: { size },
      modal
    } = this.state

    const startItem = current === 1 ? 1 : ((current - 1) * size) + 1
    const endItem = current * size > count ? count : current * size

    return (
      <div className='query-logs-new stock-adjustment'>
        <div ref={this.headerRef} className='stock-adjustment-header'>
          <ContentHeader>{translate('log.query')}</ContentHeader>
          {showBackToSourceButton && (
            <a
              href='#log-query-back'
              className='query-logs-back-link'
              onClick={(e) => {
                e.preventDefault()
                this.handleLogQueryNavBack()
              }}
            >
              <span className='query-logs-back-chevron' aria-hidden>&lt;</span>
              {translate('query.logs.back')}
            </a>
          )}
        </div>

        {showInitialFilter ? (
          <div className='content-filter'>
            <div className='common-report query-logs-new'>
              <div className='content'>
                <div className='filters'>
                  <h2>{translate('commonReport.filters')}</h2>
                  <Form
                    fields={this.formFields}
                    onSubmit={(params) => this.handleFilter(params)}
                    translate={translate}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='content-main'>
            <div ref={this.filterRef} className='spacing-end'>
              <div className='spacing-end-inner'>
                <div className='query-logs-store-func-container'>
                  <span className='query-logs-store-func'>{this.renderHeaderText(filterValues, translate)}</span>
                </div>
              </div>
              <div>
                <Button
                  className='new-button-style'
                  text={translate('mobile.filter')}
                  onClick={() => this.setState({ showSideFilter: true })}
                  svgIcon
                  svgComponent={<FilterIconSVG newDesign={false} className="default-relatory-svg size-filter-default-svg" />}
                />
              </div>
            </div>
            <SideFilter
              translate={translate}
              setSideFilterVisible={() =>
                this.setState({ showSideFilter: false })
              }
              functionalityOptions={this.functionalityOptions}
              handleFilter={(values) => this.handleFilter(values)}
              initialValues={filterValues}
              showSideFilter={showSideFilter}
            />
            <div
              ref={this.tableRef}
              className='stock-adjustment-table new'
            >

              <div className={`outer-table stock-transfer-outer-table ${list.length < 1 ? 'no-box-shadow' : ''}`}>
                <div className='flex'>
                  {list.length ? (
                    <QueryLogsTable
                      fetchDir={this.fetchDir}
                      logs={list}
                      openModal={this.openModal}
                      translate={translate}
                      handleDownload={this.handleDownload}
                      initialDirection={this.state.direction}
                      functionality={filterValues.functionality}
                    />
                  ) : (
                    <div className='relatory-no-data pictogram-empty'>
                      <p className='pictogram-empty-title'>{translate('no.results')}</p>
                      <p className='no-result-filter'>{translate('no.results.please')}</p>
                    </div>
                  )}
                </div>
                {list.length ? (
                  <Row className="new-relatory-row stock-transfer-pagination">
                    <Col className="align-center margin-bottom">
                      <NewPagination
                        navClass='pagination new-relatory'
                        count={count}
                        current={current}
                        getPage={this.getPage}
                        pages={pages}
                      />
                      <div className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                        <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
                        <Col xs={4}>
                          <SizeSelect
                            components={{ DropdownIndicator: this.DropdownIndicator }}
                            isSearchable={false}
                            styles={colourStyles}
                            classNamePrefix='react-select'
                            onChange={(option) => this.getSize(option.value)}
                            options={PAGINATION_OPTIONS}
                            value={PAGINATION_OPTIONS.find((i) => i.value === size)}
                            menuPlacement='top'
                          />
                        </Col>
                      </div>
                      <div className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                        <Col>{translate('pagination.size.show')} {startItem} - {endItem} {translate("pagination.size.of")} {count} {translate("pagination.size.items")}</Col>
                      </div>
                    </Col>
                  </Row>
                ) : null}
              </div>
            </div>
          </div>
        )}

        {modal.render && this.renderModal()}
      </div>

    )
  }
}

const mapStateToProps = ({ paginateReducer, queryLogReducer }) => ({
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  list: queryLogReducer.get.record,
  filters: queryLogReducer.filters,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...queryLogActions,
      ...reportActions,
    },
    dispatch
  )

const QueryLogsTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(QueryLogs)

export default connect(mapStateToProps, mapDispatchToProps)(QueryLogsTranslated)

export { QueryLogs }

QueryLogs.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    query: PropTypes.object,
  }),
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchQueryLog: PropTypes.func,
  fetchFilter: PropTypes.func,
  clearQueryLog: PropTypes.func.isRequired,
  filters: PropTypes.object,
  list: PropTypes.array,
  current: PropTypes.number,
  pages: PropTypes.number,
  count: PropTypes.number,
}
